import { useState, Suspense } from 'react';
import { useAppContext, SET_DESIGN_NAME } from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { useUrlState } from '../utils/urlState';
import PreviewSVG from '../components/PreviewSVG';
import { componentMap } from '../components/ChoosePlantSideWindow';
import nextButton from '../images/ui_buttons/next_button.png';
import backButton from '../images/ui_buttons/back_button.png';
import { MobileView, BrowserView } from 'react-device-detect';
import SummaryOneMobile from './SummaryOne.mobile';

const SummaryOne = () => {
	const [userInput, setUserInput] = useState('');
	const [isEditing, setIsEditing] = useState(false);
	const [error, setError] = useState('');
	const navigate = useNavigate();
	const { navigateWithParams } = useUrlState();
	const { state, dispatch } = useAppContext();
	const {
		designName,
		zone,
		style,
		sunlight,
		windows,
		facade,
		houseSize,
		shape,
		bedSize,
		bedConfig,
		chosenPlants,
	} = state.currentDesign;

	const SelectedGardenBed = bedConfig ? componentMap[bedConfig] : null;

	// Handle design name submission
	const handleChangeDesignName = (event) => {
		setUserInput(event.target.value);
	};

	// Handle submitting the design name
	const handleSubmitDesignName = () => {
		if (userInput.trim()) {
			dispatch({ type: SET_DESIGN_NAME, payload: userInput });
			setIsEditing(false);
			setError('');
		}
	};

	// Handle editing the design name
	const handleEditDesignName = () => {
		setIsEditing(true);
		setUserInput(designName || '');
	};

	// Navigate to the next screen
	const handleNext = () => {
		if (!designName) {
			setError('Please set a design name before proceeding.');
			return;
		}
		navigateWithParams('/summary-two');
	};

	// Navigate to the previous screen
	const handleBack = () => {
		navigate('/choose-plants');
	};

	console.log('Zone: ', zone);
	console.log('Style: ', style);
	console.log('Sunlight: ', sunlight);
	console.log('Windows: ', windows);
	console.log('Facade: ', facade);
	console.log('House Size: ', houseSize);
	console.log('Shape: ', shape);
	console.log('Bed Size: ', bedSize);
	console.log('BedId: ', bedConfig);
	console.log('ChosenPlants: ', chosenPlants);

	return (
		<>
			<MobileView>
				<SummaryOneMobile />
			</MobileView>
			<BrowserView>
				<div className='full-container'>
					<header>
						<button onClick={handleBack}>
							<img src={backButton} alt='Back' className='button-image' />
						</button>
						<h1>Summary</h1>
						<button onClick={handleNext}>
							<img src={nextButton} alt='Next' className='button-image' />
						</button>
					</header>
					<h2>Plot Review</h2>
					<div className='summary-one-body-container'>
						<div className='summary-one-left-container'>
							<div className='summary-design-name-container'>
								{designName && !isEditing ? (
									<>
										<svg
											width='20'
											height='20'
											viewBox='0 0 72 72'
											fill='none'
											xmlns='http://www.w3.org/2000/svg'
											className='summary-design-name-edit-button'
											onClick={handleEditDesignName}>
											<path
												d='M0 57.01V72.01H15L59.24 27.77L44.24 12.77L0 57.01ZM70.84 16.17C72.4 14.61 72.4 12.09 70.84 10.53L61.48 1.17C59.92 -0.39 57.4 -0.39 55.84 1.17L48.52 8.49L63.52 23.49L70.84 16.17Z'
												fill='white'
											/>
										</svg>
										<h2 className='summary-design-name'>{designName}</h2>
									</>
								) : (
									<div className='summary-design-name-input-container'>
										<input
											type='text'
											id='designName'
											className='summary-design-name-input'
											placeholder='Please name your design'
											onChange={handleChangeDesignName}
											value={userInput}
										/>
										<button
											onClick={handleSubmitDesignName}
											className='summary-design-name-submit-button'>
											Submit
										</button>
									</div>
								)}
							</div>
							{error && <p className='error-message'>{error}</p>}
							<div className='summary-one-garden-image-container'>
								{SelectedGardenBed ? (
									<Suspense fallback={<div>Loading garden bed layout...</div>}>
										<SelectedGardenBed />
									</Suspense>
								) : (
									<p>No garden bed found</p>
								)}
							</div>
							<div className='summary-one-info-container'>
								<h3>
									Zone: {zone}
									<br />
									Sunlight: {sunlight}
									<br />
									Style: {style}
									<br />
									Bed Size: {bedSize}
								</h3>
							</div>
						</div>
						<div className='summary-one-right-container'>
							<PreviewSVG />
						</div>
					</div>
				</div>
			</BrowserView>
		</>
	);
};

export default SummaryOne;
